import React from 'react';
import RoleDashboardShell from '@/presentation/dashboard/RoleDashboardShell';
import { useRoleDashboardConfig } from '@/presentation/dashboard/useRoleDashboardConfig';
import { useDashboardHomeCopy } from '@/presentation/dashboard/dashboardHomeLocale';
import PublicIeltsQuizSpotlight from '@/presentation/quiz/PublicIeltsQuizSpotlight';

export default function StudentDashboard({ session, onLogout }) {
  const config = useRoleDashboardConfig(session);
  const t = useDashboardHomeCopy(session);
  const displayName = session?.user?.name || t.guestName;

  return (
    <RoleDashboardShell
      session={session}
      appTitle={config.appTitle}
      systemTagline={config.systemTagline}
      roleLabel={config.roleLabel}
      menuItems={config.menuItems}
      onLogout={onLogout}
    >
      <div className="mx-auto max-w-7xl space-y-6">
        <PublicIeltsQuizSpotlight />

        <section className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-center">
          <div>
            <h1 className="font-headline text-4xl font-extrabold">{t.heroGreeting(displayName)}</h1>
            <p className="mt-2 text-slate-600">{t.heroLine}</p>
          </div>
          <div className="rounded-xl bg-white px-6 py-4 shadow-sm">
            <p className="text-xs font-bold uppercase tracking-wide text-slate-500">{t.streakLabel}</p>
            <p className="text-2xl font-black text-emerald-700">{t.streakValue}</p>
          </div>
        </section>

        <div className="grid gap-6 md:grid-cols-12">
          <section className="space-y-6 md:col-span-8">
            <article className="rounded-3xl bg-gradient-to-br from-cyan-500 to-blue-600 p-8 text-white">
              <h2 className="font-headline text-3xl font-extrabold">{t.urgentTitle}</h2>
              <p className="mt-2 max-w-xl text-cyan-50">{t.urgentBody}</p>
              <button type="button" className="mt-6 rounded-xl bg-white px-5 py-3 text-sm font-bold text-cyan-700">
                {t.doNow}
              </button>
            </article>
            <div className="grid gap-4 sm:grid-cols-2">
              <article className="rounded-2xl border border-sky-100 bg-white p-6 shadow-sm">
                <h3 className="text-lg font-bold">{t.demoRows[0][0]}</h3>
                <p className="mt-1 text-sm text-slate-500">{t.demoRows[0][1]}</p>
              </article>
              <article className="rounded-2xl border border-sky-100 bg-white p-6 shadow-sm">
                <h3 className="text-lg font-bold">{t.demoRows[1][0]}</h3>
                <p className="mt-1 text-sm text-slate-500">{t.demoRows[1][1]}</p>
              </article>
            </div>
          </section>

          <section className="space-y-6 md:col-span-4">
            <article className="rounded-3xl bg-white p-6 shadow-sm">
              <h3 className="font-headline text-lg font-bold">{t.achievementsTitle}</h3>
              <div className="mt-4 grid grid-cols-3 gap-3">
                {['workspace_premium', 'military_tech', 'lock'].map((icon) => (
                  <div key={icon} className="flex h-14 w-14 items-center justify-center rounded-full bg-sky-50">
                    <span className="material-symbols-outlined text-2xl text-emerald-700">{icon}</span>
                  </div>
                ))}
              </div>
            </article>
            <article className="rounded-3xl bg-cyan-100 p-6">
              <h3 className="font-headline text-lg font-bold">{t.leaderboardTitle}</h3>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="rounded-xl bg-white/70 p-3 font-medium">1. Thùy Linh — 12,450 XP</li>
                <li className="rounded-xl bg-white p-3 font-bold">2. {displayName} — 11,900 XP</li>
                <li className="rounded-xl bg-white/70 p-3 font-medium">3. Hoàng Minh — 10,200 XP</li>
              </ul>
            </article>
          </section>
        </div>
      </div>
    </RoleDashboardShell>
  );
}

